export const cancelHint = (count: number) =>
  `Если за 18 часов или за 2 часа до начала игры не присоединится ${count} игрока(ов), то игра будет автоматически отменена, деньги вернутся всем участникам в полном объеме`;
